import { createAction, createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
  ISimplifiedBorrowerParams,
} from 'api/digifi/BorrowersApi';
import { RootState } from 'store';
import { FormLayoutData } from 'api/types';
import rejectWithValue from 'utils/rejectWithValue';
import { borrowersApi } from 'store/api';

enum BorrowersActionType {
  GetBorrowerData = 'borrowers/getBorrowerData',
  UpdateBorrower = 'borrowers/updateBorrower',
  GetExistingBorrowerData = 'borrowers/getExistingBorrowerData',
}

const borrowersAdapter = createEntityAdapter<ISimplifiedBorrowerParams>();

const initialState = borrowersAdapter.getInitialState();

export const getBorrower = createAsyncThunk(
  BorrowersActionType.GetBorrowerData,
  async (_, thunkApi) => {
    try {
      const response = await borrowersApi.getBorrower();

      return [response];
    } catch (error) {
      return rejectWithValue(error, thunkApi);
    }
  },
);

export const updateBorrower = createAsyncThunk<ISimplifiedBorrowerParams, { variables: FormLayoutData }>(
  BorrowersActionType.UpdateBorrower,
  async ({ variables }, thunkApi) => {
    try {
      return await borrowersApi.updateBorrower(
        variables,
      );
    } catch (error) {
      return rejectWithValue(error, thunkApi);
    }
  },
);

export const getExistingBorrowerData = createAsyncThunk<ISimplifiedBorrowerParams>(
  BorrowersActionType.GetExistingBorrowerData,
  async (_, thunkApi) => {
    try {
      return await borrowersApi.getExistingBorrowerData();
    } catch (error) {
      return rejectWithValue(error, thunkApi);
    }
  },
);

export const resetBorrowers = createAction('borrowers/resetBorrower');

const borrowersSlice = createSlice({
  name: 'borrowersSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBorrower.fulfilled, (state, { payload }) => {
        borrowersAdapter.setAll(state, payload);
      })
      .addCase(updateBorrower.fulfilled, (state, { payload }) => {
        borrowersAdapter.setOne(state, payload);
      })
      .addCase(getExistingBorrowerData.fulfilled, (state, { payload }) => {
        borrowersAdapter.setOne(state, payload);
      })
      .addCase(resetBorrowers, (state) => {
        borrowersAdapter.removeAll(state);
      });
  },
});

export const { selectAll: selectAllBorrowers } = borrowersAdapter.getSelectors((state: RootState) => state.borrowers);

export default borrowersSlice.reducer;
